/**
 * AndVSankey - 桑基图组件
 * 基于 Ant Design Charts Sankey
 */
import React from 'react';
import { Sankey } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVSankeyProps } from '../base/types';

const DEFAULT_SANKEY_DATA = [
  { source: '年度总预算', target: '影像中心', value: 320 },
  { source: '年度总预算', target: '检验中心', value: 240 },
  { source: '年度总预算', target: '手术室', value: 180 },
  { source: '年度总预算', target: '后勤维保', value: 120 },
  { source: '影像中心', target: 'CT 设备', value: 150 },
  { source: '影像中心', target: 'MRI 设备', value: 120 },
  { source: '影像中心', target: '超声设备', value: 50 },
  { source: '检验中心', target: '生化分析仪', value: 100 },
  { source: '检验中心', target: '免疫分析仪', value: 80 },
  { source: '检验中心', target: '血球仪', value: 60 },
  { source: '手术室', target: '麻醉机', value: 70 },
  { source: '手术室', target: '无影灯', value: 55 },
  { source: '手术室', target: '手术床', value: 55 },
  { source: '后勤维保', target: '预防性保养', value: 70 },
  { source: '后勤维保', target: '应急维修', value: 50 },
];

const SankeyWithBase = withBaseChart<AndVSankeyProps>(Sankey, {
  chartType: 'AndVSankey',
  defaultHeight: 300,
  defaultData: DEFAULT_SANKEY_DATA,
});

export const AndVSankey: React.FC<AndVSankeyProps> = (props) => {
  const { valueField, layout, ...baseProps } = props;

  const chartProps: Record<string, unknown> = { ...baseProps };

  if (valueField) chartProps.valueField = valueField;

  const layoutConfig = parseJsonProp(layout);
  if (layoutConfig !== undefined) chartProps.layout = layoutConfig;

  return <SankeyWithBase {...chartProps} />;
};

export type { AndVSankeyProps };
export default AndVSankey;
